import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'

import {store} from '@/myops/core'

store.registerModule('appConfig',appConfigStoreModule)


export default store

